import { RestClient } from "./restClient";

export class ReportService {
	constructor(options) {
		this._options = options;
		this._restClient = new RestClient();
	}

	getGraphQLReports(graphqlQuery, callback) {
		const url = "/reports-app/api/graphql";
		const body = JSON.stringify({
			query: graphqlQuery
		});
		this._restClient.exec_post(url, body, callback);
	}
}
